import { useCallback } from 'react';
import { cn } from '../lib/util';

/* Image with a warm placeholder background + graceful fade-in on load.
   Self-hosted photos live in /public/images. Handles cached images
   (whose `load` may fire before React attaches the handler). */
export function Img({
  src,
  alt,
  className,
  imgClassName,
  eager = false,
}: {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
}) {
  const reveal = useCallback((el: HTMLImageElement | null) => {
    if (el && el.complete) el.style.opacity = '1';
  }, []);
  return (
    <div className={cn('overflow-hidden', className)} style={{ background: 'linear-gradient(135deg, #f0e2cb, #e3c79a)' }}>
      <img
        ref={reveal}
        src={src}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        className={cn('h-full w-full object-cover', imgClassName)}
        onLoad={(e) => { e.currentTarget.style.opacity = '1'; }}
        style={{ opacity: 0, transition: 'opacity 0.8s ease, transform 0.7s ease' }}
      />
    </div>
  );
}
